module.exports = "<router-outlet></router-outlet>\r\n<spinner [backgroundColor]=\"'#ff3333'\"></spinner>"